import axios from '@/plugins/axios'
import format from 'date-fns/format'
import subDays from 'date-fns/subDays'
import addDays from 'date-fns/addDays'

export default {
  namespaced: true,

  state: {
    loading: false,
    page: 1,
    page_size: 10,
    order_column: 'name',
    order_type: 'asc',
    channels: [],
    channel_chart: [],
    date_range: [
      format(subDays(new Date(), 7), 'yyyy-MM-dd'),
      format(addDays(new Date(), 1), 'yyyy-MM-dd')
    ],
    csv: 0,
    LineChartSett: {
      width: 'auto',
      height: 500,
      is3D: true,
      colors: ['#085178', '#e80021', '#1b9e77', '#2c67a5'],
      curveType: 'none',
      isStacked: 'relative',
      vAxis: {
        maxAlternation: 4,
        minorGridlines: {
          count: 15
        },
        minValue: 0,
        slantedText: true,
        slantedTextAngle: 70,
        gridlines: {
          count: 15
        },
        textStyle: {
          fontSize: 12
        },
        format: 'short',
        viewWindowMode: 'pretty'
      },
      hAxis: {
        format: 'short',
        viewWindowMode: 'pretty',
        textStyle: {
          fontSize: 13
        },
        color: '#FF0000'
      },
      tooltip: {
        textStyle: {
          color: '#000',
          fontSize: 16,
          isHtml: true
        },
        showColorCode: true
      },
      lineWidth: 2.3,
      legend: {
        position: 'bottom',
        textStyle: {
          color: '#303133',
          fontSize: 14,
          bold: true
        }
      },
      chartArea: {
        left: '15%',
        top: '5%',
        width: '100%',
        height: '70%'
      }
    }
  },

  mutations: {
    setDateRange(state, payload) {
      state.date_range = [payload[0], payload[1]]
    },
    setPage(state, payload) {
      state.page = payload
    },
    setPageSize(state, payload) {
      state.page_size = payload
    },
    setOrdering(state, payload) {
      state.order_column = payload.column
      state.order_type = payload.type
    },
    setChannels(state, payload) {
      state.channels = payload
    },
    setChannelChart(state, payload) {
      state.channel_chart = payload
    },
    setLoading(state, payload) {
      state.loading = payload
    },
    setCsv(state, payload) {
      state.csv = payload
    },
  },

  actions: {
    readMyChannels({ commit, state }, filters = null) {
      commit('setLoading', true)

      let ls = localStorage.getItem('channel_report_filter')
      filters = JSON.parse(ls)

      axios.label
        .get('mychannels', {
          params: {
            page: state.page,
            page_size: state.page_size,
            order_column: state.order_column,
            order_type: state.order_type,
            csv: state.csv,
            ...filters
          }
        })
        .then(r => {
          if(state.csv == 1){
            state.csv = 0
            const url = window.URL.createObjectURL(new Blob([r.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'report_my_channels.csv')
            document.body.appendChild(link)
            link.click()
          }
          else {
            commit('setChannels', r.data.data)
          }
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },

    readChannelChart({ commit }, data) {
      axios.label
        .get(`mychannels/${data.id}`, {
          params: {
            start: data.start,
            end: data.end
          }
        })
        .then(r => {
          commit('setChannelChart', r.data.data)
          // commit('setLoading', false)
        })
        .catch(() => {
          // commit('setLoading', false)
        })
    }
  },

  getters: {
    channel_chart_views: state => {
      let result = [['Date', 'Views']]
      state.channel_chart.map(s => {
        const date = new Date(s.date)
        result.push([date.toDateString().slice(3, 15), s.views])
      })
      return result
    },
    channel_chart_subscribers: state => {
      let result = [['Date', 'Subscribers']]
      state.channel_chart.map(s => {
        const date = new Date(s.date)
        result.push([date.toDateString().slice(3, 15), s.subscribers])
      })
      return result
    }
  }
}
